import { createContext, useContext, useMemo, useState, useCallback } from 'react'

const ToastCtx = createContext({ notify: () => {} })

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([])
  const notify = useCallback((msg, opts = {}) => {
    const id = Math.random().toString(36).slice(2)
    const dur = typeof opts.duration === 'number' ? opts.duration : 3000
    setToasts((t) => [...t, { id, msg }])
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), dur)
  }, [])
  const value = useMemo(() => ({ notify }), [notify])
  return (
    <ToastCtx.Provider value={value}>
      {children}
      <div style={{ position: 'fixed', right: 16, bottom: 16, display: 'flex', flexDirection: 'column', gap: 8, zIndex: 9999 }}>
        {toasts.map((t) => (
          <div key={t.id} style={{ background: '#333', color: '#fff', padding: '10px 12px', borderRadius: 6, maxWidth: 420, boxShadow: '0 2px 10px rgba(0,0,0,.2)' }}>{t.msg}</div>
        ))}
      </div>
    </ToastCtx.Provider>
  )
}

export function useToast() {
  return useContext(ToastCtx)
}

